// API Configuration
// This will use environment variables in production (set in Vercel)
// and fall back to localhost for local development

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default API_URL;
